export default __webpack_public_path__ + "static/media/Trustage dark.81151770.svg";